import { useTranslation } from "react-i18next";
import CommonIcons from "@base/assets/icons";
import { hasText } from "@base/modules/doctor/doctorProfile";
import { IDoctor } from "@base/modules/doctor/interface/doctor.interface";

interface IProps {
  doctor: IDoctor;
}

/**
 * Title, years of experience and facility. A doctor without a title just has no title row; experience
 * is always shown, even at zero.
 */
export default function DoctorFacts({ doctor }: IProps) {
  //! state
  const { t } = useTranslation();

  const facts = [
    { key: "title", icon: <CommonIcons.IconDoctorTitle />, text: doctor.title?.title_name },
    {
      key: "experience",
      icon: <CommonIcons.IconDoctorExperience />,
      text: t("doctorDetail.yearsOfExperience", { count: doctor.year_of_experiences ?? 0 }),
    },
    { key: "site", icon: <CommonIcons.IconDoctorSite />, text: doctor.site_name },
  ].filter((fact) => hasText(fact.text));

  //! render
  return (
    <div className="flex flex-col gap-3">
      {facts.map((fact) => (
        <div key={fact.key} className="flex items-center gap-3">
          <span className="flex-none flex text-common-primary">{fact.icon}</span>
          <span className="text-sm lg:text-base font-['Inter'] text-common-maintext">{fact.text}</span>
        </div>
      ))}
    </div>
  );
}
